export default function contactsHierarchy(data) {

  this.popup("contactsHierarchy", {
    params: data,
    header: this.translate("LBL_CONTACTS_HIERARCHY", "Contacts")
  });
}
